import type { SortObject, SortOption } from './types';

export const getSortObject = (sortItems: SortOption[]): SortObject =>
  sortItems.length > 0
    ? {
        [sortItems[0].name]: sortItems[0].order,
      }
    : {};
